import { Quiz409Translations } from './quizExpired.translation.pl';

export const quizToManyRevisitsTranslations: Quiz409Translations = {
  title: 'Ups! Zbyt wiele prób!',
  subMessage:
    'W tym roku nie udało Ci się ukończyć wszystkich zadań kwalifikacyjnych. Nie możesz się już zalogować.',
  buttons: {
    back: 'Start',
  },
};
